export enum Role {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  USER = "USER",
}

export enum Environment {
  DEVELOPMENT = "localhhost",
  PRODUCTION = "globalga.co",
}

export enum Urls {
  DEVELOPMENT = "http://localhost:3000",
  PRODUCTION = "globalga.co",
}

export enum RevenueChartTypes {
  CLIENT = "CLIENT",
  DASHBOARD = "DASHBOARD"
}

export enum DataGridTypes {
  CLIENT = "CLIENT",
  DASHBOARD = "DASHBOARD"
}

export enum ClientTypes {
  ATM = "ATM",
  VENDING = "VENDING",
  AIRBNB = "AIRBNB"
}

export type FilterType = {
  name: string;
  value: ClientTypes | string;
}

export type RegisterRequest = {
  username: string;
  password: string;
  email: string;
  role: Role;
  isActive: boolean;
};

export type Client = {
  id?: string; // an id wont be generated on creation only on a fetch, so optional
  clientName: string;
  clientEmail: string;
  location: string;
  clientPhoneNumber: string;
  sn?: string;
  revenue: number[];
  percentage: number;
  status: boolean;
  type: ClientTypes;
  clientNotes?: Array<Comment>;
  orderDate: string,
  startDate: string;
  contractUrl?: string;
};

export type Comment = {
  id?: string;
  note: string;
  createdAt?: string;
};

export type User = {
  username: string;
  password: string;
}

export type UserResponse = {
  userId: string;
  role: Role;
  email: string;
  username: string;
  jwtToken: string;
}

export type PasswordChangeRequest = {
  currentPassword: string;
  newPassword: string;
}
